import { chakra } from "@chakra-ui/system";
import React from "react";

export function AP(props: any): React.ReactElement {
  return (
    <chakra.svg viewBox="0 0 69 80" {...props}>
      <title>logo/ap copy 3</title>
      <defs>
        <polygon
          id="path-1"
          points="0 0 69.118695 0 69.118695 79.9897778 0 79.9897778"
        />
      </defs>
      <g
        id="Header-&amp;-Footers"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Footers" transform="translate(-200.000000, -352.000000)">
          <g id="Group-4" transform="translate(100.000000, 292.000000)">
            <g id="logo/ap-copy-3" transform="translate(100.000000, 60.000000)">
              <g id="Group-4" transform="translate(0.000000, 0.000000)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                </mask>
                <g id="Clip-2" />
                <polygon
                  id="Fill-1"
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                  points="0.000666739823 71.6506667 69.118695 71.6506667 69.118695 0 0.000666739823 0"
                />
                <polyline
                  id="Fill-3"
                  fill="#FF322E"
                  mask="url(#mask-2)"
                  points="0 71.6506667 69.118695 71.6506667 69.118695 80.0031111 0.000666739823 80.0031111 0 71.6506667"
                />
              </g>
              <polyline
                id="Fill-5"
                fill="#000000"
                points="15.9095234 18.8546667 4.2911375 53.7011111 12.7031716 53.7011111 20.5947041 29.0704444 24.550027 41.3844444 19.4334656 41.3844444 17.3901303 48.4137778 26.8078303 48.4137778 28.5060166 53.7011111 37.1585216 53.7011111 25.5414691 18.8546667 15.9095234 18.8546667"
              />
              <path
                d="M50.3773053,18.8546667 L38.2999801,18.8546667 L38.2999801,53.7011111 L46.6520077,53.7011111 L46.6520077,25.8842222 L50.017488,25.8842222 C53.9225832,25.8842222 56.1459382,27.7462222 56.1459382,31.1108889 C56.1459382,34.4153333 53.9225832,36.338 50.017488,36.338 L49.476762,36.338 L49.476762,43.3673333 L50.3773053,43.3673333 C59.3902942,43.3673333 64.6779855,38.8308889 64.6779855,31.1108889 C64.6779855,23.2404444 59.3902942,18.8546667 50.3773053,18.8546667"
                id="Fill-6"
                fill="#000000"
              />
            </g>
          </g>
        </g>
      </g>
    </chakra.svg>
  );
}
